<template>
  <div>
    <div v-if="$route.path === '/main'" class="fix-height">
        <div v-show="$store.state.globalPreloader" id="preloader">
            <div id="loader"></div>
        </div>
      <router-view :class="{'callme':$store.state.project === 'callme'}"></router-view>
    </div>
    <div v-else>
      <div v-show="$store.state.globalPreloader" id="preloader">
          <div id="loader"></div>
      </div>
      <router-view :class="{'callme':$store.state.project === 'callme'}"></router-view>
    </div>
  </div>
  <!--<div v-else @click="check" style="position:absolute; bottom:0; right:0; opacity:0; width:100px; height:100px;"></div>-->
</template>

<style>
  @import 'assets/global_styles.css';
  @import 'assets/all.css';
  @import 'assets/all.css';
</style>

<script>

export default {
  name: 'App',
  data () {
    return {
      count: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue